import React, {Component} from 'react';
import {Button, Col, Modal, Row} from 'react-bootstrap';

export default class CustomModalDialog extends Component {
  constructor(props, context) {
    super(props, context);
  }
  render() {
    if (!this.props.show) {
      return null;
    }

    return (
      <Modal 
        onExited={this.props.closeModal}
        show={this.props.show}
        onHide={this.props.closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>{this.props.modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.props.modalContent()}
        </Modal.Body>
        <Modal.Footer className="top20">
          <Row className="left0">
            <Col md={12} sm={12} xs={12} className="pleft0">
              <Button 
                className="pull-right btn right20 btn-default" 
                type="button"
                onClick={this.props.closeModal}>
                Cancel
              </Button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    );
  }
}

